import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Dashboard from './Pages/Dashboard';
import Login from './Component/Header/Login/Login';
import PatientLogin from './Component/Header/Login/PatientLogin';
import Admin from './Admin';
import Patient from './Component/Header/MAnage Patient/Patient';
import ManageDoctors from './Component/Header/Manage doctors/ManageDoctors';
import Staff from './Component/Header/ManageStaff/Staff';
import ManageAppointment from './Component/Manage Appointment/ManageAppointment';
import ManageLabs from './Component/ManageLabs/ManageLabs';
import Protected from './Component/Protected';
import PermissionRoute from './Component/PermissionRoute';
import Addappointment from './Component/Manage Appointment/Appointment/Addappointment';
import Addpatient from './Component/Header/MAnage Patient/Addpatient';
import Billing from './Component/Billing/Billing';
import ViewInvoice from './Component/Billing/ViewInvoice';
import Pharmacy from './Component/Pharmacy/Pharmacy';
import Insurance from './Component/Insuranse/Insurance';
import ViewInsurance from './Component/Insuranse/ViewInsurance';
import ViewCompany from './Component/Insuranse/ViewCompany';
import EditInsurance from './Component/Insuranse/EditInsurance';
import Medical from './Component/Medical/Medical';
import Schedule from './Component/Medical/Schedule';
import Changepassword from './Component/Profile/Changepassword';
import Register from './Component/Header/Login/Register';
import Appointment2 from './Component/Appointment2/Appointment2';
import DoctorBooking from './Component/Header/ManageStaff/DoctorBooking';
import Myprofile from './Setting/Myprofile';
import DoctorDashboard from './Component/Header/ManageStaff/DoctorDashboard';
import Reports from './Component/Reports/Reports';
import Homepage from './Pages/Homepage';
import BarCharTwo from './Pages/BarChartTwo';
import Service from './Component/service/Service';
import EditPatient from './Component/Header/MAnage Patient/EditPatient';
import Calander from './Component/Header/calander/Calander';
import Vierappointment from './Component/Appointment2/Vierappointment';
import CompanyClaims from './Component/Insuranse/CompanyClaims';
import Category from './Component/Pharmacy/Category/Category';
import Labs from './Component/addlabs/Labs';
import EditInventory from './Component/Pharmacy/EditInventory';
import ViewInventory from "./Component/Pharmacy/ViewInventory";
import ViewRx from "./Component/Pharmacy/ViewRxList";
import AddInventory from './Component/Pharmacy/AddInventory';
import AddRxList from './Component/Pharmacy/AddRxList';
import ViewPrescription from './Component/Pharmacy/ViewPrescription';
import NewRequest from './Component/ManageLabs/NewRequest';
import ViewLab from './Component/ManageLabs/ViewLab';
import ViewLabDetails from './Component/addlabs/ViewLab';
import EditLab from './Component/ManageLabs/EditLab';
import SettingsDashboard from './Setting/SettingsDashboard';
import SettingNew from './Component/SettingNew/SettingNew';
import BusinessSetting from './Component/SettingNew/BusinessSetting';
import FinanceSetting from './Component/SettingNew/FinanceSetting';
import Currency from './Component/SettingNew/Currency';
import NotificationCenter from './Component/SettingNew/NotificationCenter';
import Security from './Component/SettingNew/Security';
import StaffPermissions from './Component/SettingNew/StaffPermissions';
import BarcodeScanner from './Component/BarcodeScanner/BarcodeScanner';
import ViewUser from './Component/Header/ManageStaff/ViewUser';
import ViewStaff from './Component/Header/ManageStaff/ViewStaff';
import ViewDoctor from './Component/Header/ManageStaff/ViewDoctor';
import ViewNurse from './Component/Header/ManageStaff/ViewNurse';
import EditDoctor from './Component/Header/ManageStaff/EditDoctor';
import EditNurse from './Component/Header/ManageStaff/EditNurse';
import EditStaff from './Component/Header/ManageStaff/EditStaff';
import AddDoctor from './Component/Header/ManageStaff/AddDoctor';
import AddNurse from './Component/Header/ManageStaff/AddNurse';
import AddStaff from './Component/Header/ManageStaff/AddStaff';
import LabServices from './Component/ManageLabs/LabServices';
import Icdlist from './Component/Medical/Icdlist';
import ServiceCategory from './Component/Medical/ServiceCategory';
import Allergy from './Component/Medical/Allergy';
import LabTests from './Component/Medical/LabTests';
import BrowserGaugeChart from './Component/Manage Appointment/HalfPieChart';
import Auto from './Component/Medical/Auto';
import ChronicIllness from './Pages/ChronicIllness';
import ChiefComplaint from './Pages/ChiefComplaint';
import Hisstoryodpastillness from './Pages/Hisstoryodpastillness';
import Historyodpresentillness from './Pages/Historyodpresentillness';
import Extranotes from './Pages/Extranotes';
import Advice from './Pages/Advice';
import Examinationsymetic from './Pages/Examinationsymetic';
import Examinationlocal from './Pages/Examinationlocal';
import Examinationgeneral from './Pages/Examinationgeneral';
import Treatplan from './Pages/Treatplan';
import EditProfile from './Component/Profile/EditProfile';
import ICDstandardlist from './Pages/ICDstandardlist';
import AddInsurance from './Component/Insuranse/AddInsurance'
import AddCompany from './Component/Insuranse/AddCompany'
import AddPrescription from './Component/Manage Appointment/AddPrescription';
import PaymentMethod from './Component/SettingNew/PaymentMethod';
import EditRxList from './Component/Pharmacy/EditRxList';
import Physosocial from './Component/Medical/Physosocial';
import FamilyHistory from './Component/Medical/FamilyHistory';
import DentalNoteTemplates from './Component/Medical/DentalNoteTemplates';
import UploadTypes from './Component/Medical/UploadTypes';
import PatientBilling from './Component/PatientServices/PatientBilling';
import Dentalprescription from './Component/Manage Appointment/Dental/Dentalprescription';
import TermCodition from './Component/SettingNew/TermCodition';
import ApiIntegration from './Component/SettingNew/ApiIntegration';
import SmsSetting from './Component/SettingNew/SmsSetting';
import EmailSetting from './Component/SettingNew/EmailSetting';
import WhatsappSetting from './Component/SettingNew/WhatsappSetting';
// import EditRxList from './Component/Pharmacy/EditRxList';
// import Physosocial from './Component/Medical/Physosocial';
// import FamilyHistory from './Component/Medical/FamilyHistory';
import PatientPortal from './Component/PatientPortal/PatientPortal';
import MedicalTemplates from './Pages/MedicalTemplates';
import Consents from './Pages/Consents';
import CustomForms from './Pages/CustomForms';
import OnlineBookingSetting from './Component/SettingNew/OnlineBookingSetting';
import AuditLog from './Component/SettingNew/AuditLog';
import MedicalSafety from './Component/SettingNew/MedicalSafety'
import DatabaseCleanup from './Component/SettingNew/DatabaseCleanup'
import LoyaltySystem from './Component/LoyaltySystem/LoyaltySystem';
import LoyaltyLink from './Component/LoyaltySystem/LoyaltyLink';
import Kiosk from './Component/Kiosk/Kiosk';
import KioskCheckin from './Component/Kiosk/KioskCheckin';
import Postcare from './Pages/Postcare';

// Code-split: the assistant ships as its own chunk and stays out of the main bundle.
const AssistantAdmin = lazy(() => import('./Component/Assistant/AssistantAdmin'));
const ChatAdmin = lazy(() => import('./Component/Chat/ChatAdmin'));
const AgentAdmin = lazy(() => import('./Component/Chat/AgentAdmin'));



function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/patient/login" element={<PatientLogin />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/Homepage" element={<Protected Component={Homepage} />} />
          <Route path="/patient" element={<PatientPortal />} />
          <Route
            path="/Admin"
            element={<Protected Component={Admin} />}>
            <Route path="/Admin/LoyaltySystem" element={<LoyaltySystem />} />
            <Route path="/Admin/LoyaltySystem/Link" element={<LoyaltyLink />} />
            <Route path="/Admin/Kiosk" element={<Kiosk />} />
            <Route path="/Admin/Kiosk/checkin" element={<KioskCheckin />} />
            <Route path="/Admin/dashboard" element={<PermissionRoute routePath="/Admin/dashboard" element={<Dashboard />} />} />
            <Route path="/Admin/barchartTwo" element={<BarCharTwo />} />
            <Route path="/Admin/Patient" element={<Patient />} />
            <Route path="/Admin/Service" element={<Service />} />
            <Route path="/Admin/addPatient" element={<Addpatient />} />
            <Route path="/Admin/EditPatient" element={<EditPatient />} />
            <Route path="/Admin/Changepassword" element={<Changepassword />} />
            <Route path='/Admin/appointment2' element={<Appointment2 />} />
            <Route path="/Admin/newrequest" element={<NewRequest />} />
            <Route path="/Admin/ManageDoctors" element={<ManageDoctors />} />
            <Route path="/Admin/ManageStaff" element={<Staff />} />
            <Route path="/Admin/Manageappointment" element={<ManageAppointment />} />
            <Route path="/Admin/ManageLabs" element={<ManageLabs />} />
            <Route path="/Admin/calander" element={<Calander />} />
            <Route path="/Admin/Addappointment" element={<Addappointment />} />
            <Route path="/Admin/Billing" element={<Billing />} />
            <Route path="/Admin/ViewInvoice/:id" element={<ViewInvoice />} />
            <Route path="/Admin/Pharmacy" element={<Pharmacy />} />
            <Route path="/Admin/Insurance" element={<Insurance />} />
            <Route path="/Admin/CompanyClaims/:companyId" element={<CompanyClaims />} />
            <Route path="/Admin/ViewInsurance/:id" element={<ViewInsurance />} />
            <Route path="/Admin/ViewCompany/:id" element={<ViewCompany />} />
            <Route path="/Admin/EditInsurance" element={<EditInsurance />} />
            <Route path="/Admin/Medicals" element={<Medical />} />
            <Route path="/Admin/DoctorBooking" element={<DoctorBooking />} />
            <Route path="/Admin/myprofile" element={<Myprofile />} />
            <Route path="/Admin/Prescription" element={<AddPrescription />} />
            <Route path="/Admin/EditProfile" element={<EditProfile />} />
            <Route path="/Admin/chiefComplaint" element={<ChiefComplaint />} />
            <Route path="/Admin/historyodpastillenss" element={<Hisstoryodpastillness />} />
            <Route path="/Admin/historyodpresentillness" element={<Historyodpresentillness />} />
            <Route path="/Admin/treatmentplan" element={<Treatplan />} />
            <Route path="/Admin/Extranotes" element={<Extranotes />} />
            <Route path="/Admin/examinationlocal" element={<Examinationlocal />} />
            <Route path="/Admin/examinationgeneral" element={<Examinationgeneral />} />
            <Route path="/Admin/examinationsymetic" element={<Examinationsymetic />} />
            <Route path="/Admin/Advice" element={<Advice />} />
            <Route path="/Admin/viewappointment" element={<Vierappointment />} />
            <Route path="/Admin/DoctorDashboard" element={<DoctorDashboard />} />
            <Route path="/Admin/ReportsInc" element={<Reports />} />
            <Route path="/Admin/ICDstandardlist" element={<ICDstandardlist />} />
            <Route path="/Admin/addlabs" element={<Labs />} />
            <Route path="/Admin/Category" element={<Category />} />
            <Route path="/Admin/EditInventory" element={<EditInventory />} />
            <Route path="/Admin/ViewInventory/:id" element={<ViewInventory />} />
            <Route path="/Admin/ViewRx/:id" element={<ViewRx />} />
            <Route path="/Admin/ViewPrescription/:id" element={<ViewPrescription />} />
            <Route path="/Admin/AddInventory" element={<AddInventory />} />
            <Route path="/Admin/AddRxList" element={<AddRxList />} />
            <Route path="/Admin/ViewLab/:id" element={<ViewLab />} />
            <Route path="/Admin/ViewLabDetails/:id" element={<ViewLabDetails />} />
            <Route path="/Admin/EditLab/:id" element={<EditLab />} />
            <Route path="/Admin/ViewUser" element={<ViewUser />} />
            <Route path="/Admin/dentalPrescription" element={<Dentalprescription />} />
            <Route path="/Admin/ViewStaff" element={<ViewStaff />} />
            <Route path="/Admin/ViewDoctor" element={<ViewDoctor />} />
            <Route path="/Admin/ViewNurse" element={<ViewNurse />} />
            <Route path="/Admin/EditDoctor" element={<EditDoctor />} />
            <Route path="/Admin/EditNurse" element={<EditNurse />} />
            <Route path="/Admin/EditStaff" element={<EditStaff />} />
            <Route path="/Admin/AddDoctor" element={<AddDoctor />} />
            <Route path="/Admin/AddNurse" element={<AddNurse />} />
            <Route path="/Admin/AddStaff" element={<AddStaff />} />
            <Route path="/Admin/SettingsDashboard" element={<SettingsDashboard />} />
            <Route path="/Admin/Chronicillness" element={<ChronicIllness />} />
            <Route path="/Admin/setting" element={<SettingNew />} />
            <Route path="/Admin/ICDlist" element={<Icdlist />} />
            <Route path="/Admin/Allergy" element={<Allergy />} />
            <Route path="/Admin/LabTests" element={<LabTests />} />
            <Route path="/Admin/ServiceCategory" element={<ServiceCategory />} />
            <Route path="/Admin/business_setting" element={<BusinessSetting />} />
            <Route path='/Admin/api_integration' element={<ApiIntegration />} />
            <Route path='/Admin/smsSetting' element={<SmsSetting />} />
            <Route path='/Admin/emailSetting' element={<EmailSetting />} />
            <Route path='/Admin/whatsappSetting' element={<WhatsappSetting />} />
            <Route path="/Admin/finance" element={<FinanceSetting />} />
            <Route path="/Admin/Currency" element={<Currency />} />
            <Route path="/Admin/TermCondition" element={<TermCodition />} />
            <Route path="/Admin/notification_center" element={<NotificationCenter />} />
            <Route path="/Admin/security" element={<Security />} />
            <Route path="/Admin/msafety" element={<MedicalSafety />} />
            <Route path="/Admin/AssistantSettings" element={<Suspense fallback={<div style={{padding:24}}>Loading...</div>}><AssistantAdmin /></Suspense>} />
            <Route path="/Admin/InternalChatSettings" element={<Suspense fallback={<div style={{padding:24}}>Loading...</div>}><ChatAdmin /></Suspense>} />
            <Route path="/Admin/AgentSettings" element={<Suspense fallback={<div style={{padding:24}}>Loading...</div>}><AgentAdmin /></Suspense>} />
            <Route path="/Admin/staff-permissions" element={<StaffPermissions />} />
            <Route path="/Admin/BarcodeScanner" element={<BarcodeScanner />} />
            <Route path="/Admin/labservices" element={<LabServices />} />
            <Route path="/Admin/auto" element={<Auto />} />
            <Route path="/Admin/AddInsurance" element={<AddInsurance />} />
            <Route path="/Admin/AddCompany" element={<AddCompany />} />
            <Route path="/Admin/PaymentMethod" element={<PaymentMethod />} />
            <Route path="/Admin/EditRxList" element={<EditRxList />} />
            <Route path="/Admin/FamilyHistory" element={<FamilyHistory />} />
            <Route path="/Admin/Physocial" element={<Physosocial />} />
            <Route path="/Admin/DentalNoteTemplates" element={<DentalNoteTemplates />} />
            <Route path="/Admin/patient-billing/:patientId" element={<PatientBilling />} />
            <Route path="/Admin/MedicalTemplates/MedicalNotes" element={<MedicalTemplates title="Medical Notes Templates" templateType="medical_notes" />} />
            <Route path="/Admin/MedicalTemplates/Perscriptions" element={<MedicalTemplates title="Perscription Templates" templateType="prescriptions" />} />
            <Route path="/Admin/Schedules" element={<Schedule />} />
            {/* <Route path="/Admin/EditRxList" element={<EditRxList/>} /> */}
            {/* <Route path="/Admin/FamilyHistory" element={<FamilyHistory/>} />
            <Route path="/Admin/Physocial" element={<Physosocial/>} /> */}
            <Route path="/Admin/OnlineBookingSetting" element={<OnlineBookingSetting />}  />
            <Route path="/Admin/audit-log" element={<AuditLog />} />
            <Route path="/Admin/database_cleanup" element={<DatabaseCleanup />} />
            <Route path="/Admin/Consents" element={<Consents />} />
            <Route path="/Admin/CustomForms" element={<CustomForms />} />
            <Route path="/Admin/Postcare" element={<Postcare />} />
            <Route path="/Admin/UploadTypes" element={<UploadTypes />} />
          


          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
